<h2 class="mat-dialog-title mb-2">
  Reject -
  <strong class="text-capitalize"> {{dialogTitle}}</strong>

  <button (click)="closeDialog()" type="button" class="float-end btn btn-sm">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<form [formGroup]="rejectDoctorForm" (ngSubmit)="RejectDoctor()">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Rejection Remark</mat-label>
        <textarea
          [maxLength]="100"
          matInput
          formControlName="comment"
          required
        ></textarea>
        <!-- <mat-icon matSuffix>speaker_notes</mat-icon> -->
        <mat-error *ngIf="rejectDoctorForm.get('comment').hasError('required')">
          Rejection remark is required
        </mat-error>
      </mat-form-field>
      <span class="text-info"
        >Characters Remaining:&nbsp;{{ 100 - f.comment.value?.length }}</span
      >
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="float-end">
        <button type="submit" class="btn btn-primary me-2">Submit</button>

        <button type="reset" class="btn btn-secondary" (click)="closeDialog()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</form>
